import { createFileRoute } from "@tanstack/react-router";

import MFAManageForm from "./-components/MFAManageForm";

export const Route = createFileRoute("/_authenticated/settings/mfa")({
  component: MFAManageForm,
});
